import MypageServices from '@root/modules/Sellers/Mypage/services/mypage';
import { Card, message, Tabs } from 'antd';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import '../../../../styles/pages/seller/_mypage.scss';
import BreadcrumbList from '../../Stock/components/Breadcrumb';
import SettingAccount from '../components/setting-account';
import LinkSettings from '../components/LinkSetting';
import mypage from '@root/modules/Sellers/Mypage/services/mypage';

interface IVerifyShopRespone {
  message: string;
  data: {
    shopId: string;
    shopName: string;
    isIntegrated: boolean;
  };
}

interface ResponseError {
  response: {
    data: {
      codeName: ErrorCode;
      messages: string[];
      method: string;
      moduleName: string;
      path: string;
      timestamp: string;
    };
  };
}

enum ErrorCode {
  OnlyOneShopPerIntergration = 'ONLY_ONE_SHOP_PER_INTEGRATION',
  ShopRegionNotMatchWarehouseCountry = 'SHOP_REGION_NOT_MATCH_WAREHOUSE_COUNTRY',
  ShopeeCanNotBeVerified = 'SHOPEE_CANNOT_BE_VERIFIED',
  WarehouseNotFound = 'WAREHOUSE_NOT_FOUND'
}

const Mypage = () => {
  const [infoAccount, setInfoAccount] = useState([] as any);
  const [tabActive, setTabActive] = useState('1');

  const { search } = useLocation();
  const breadcrumbList = [
    {
      tittle: '마이페이지',
      url: ''
    }
  ];

  const getApiAmazon = async () => {
    if (!!search) {
      setTabActive('2');
      getInfoAccount();
    }
  };

  const getInfoAccount = async () => {
    const data = await MypageServices.getSellerID();
    setInfoAccount(data.data);

    let nameUser = data?.data?.email.split('@')[0];

    localStorage.setItem('infoUser', nameUser);
  };

  useEffect(() => {
    if (!!search) {
      getApiAmazon();
    } else getInfoAccount();
  }, []);

  const verifyShop = async (dt: {
    shopId?: string;
    mainAccountId?: string;
    code: string;
    warehouseId: string;
  }) => {
    try {
      const res = (await mypage.verifyShop({ ...dt })) as IVerifyShopRespone;
      const shopData = res?.data;
      if (shopData) {
        window.postMessage({ type: 'REFRESH_INTERGRATION_HISTORY' }, '*');
        message.success(
          `${shopData.shopName} 연동에 성공했습니다.`
        );
      }
    } catch (error: unknown) {
      const { codeName } = (error as ResponseError).response.data;
      switch (codeName) {
        case ErrorCode.OnlyOneShopPerIntergration: {
          message.error('한번 연동 시 하나의 물류센터만 선택 가능합니다.');
          break;
        }
        case ErrorCode.ShopRegionNotMatchWarehouseCountry:
          message.error(
            '선택한 물류센터의 국가 정보가 달라 연동에 실패하였습니다.'
          );
          break;
        case ErrorCode.ShopeeCanNotBeVerified:
          message.error('Shopee를 인증할 수 없습니다.');
          break;
        case ErrorCode.WarehouseNotFound:
          message.error('창고를 찾을 수 없습니다.');
          break;
      }
    }

    //clear url param
    window.history.replaceState({}, '', window.location.pathname);

  };

  useEffect(() => {
    if (!search) {
      return;
    }

    const shopId = new URLSearchParams(search).get('shop_id');
    const mainAccountId = new URLSearchParams(search).get('main_account_id');
    const code = new URLSearchParams(search).get('code');
    const warehouseId = new URLSearchParams(search).get('warehouseId');
    if ((shopId || mainAccountId) && code && warehouseId) {
      if (shopId) {
        verifyShop({ shopId, code, warehouseId });
      } else if (mainAccountId) {
        verifyShop({ mainAccountId, code, warehouseId });
      }
    }
  }, [search]);

  const updateAgreement = () => {
    setInfoAccount((prev: any) => ({
      ...prev,
      isAgreePolicy: true
    }));
  };

  const sellingCategory: any[] = [];
  const saleChannels: any[] = [];

  infoAccount.saleCategories?.map((item: any) => {
    sellingCategory?.push(item?.id);
  });
  infoAccount.saleChannels?.map((item: any) => {
    saleChannels.push(item?.id);
  });

  const isNotShowAgreement =
    tabActive === '1'
      ? true
      : infoAccount.isAgreePolicy === undefined
      ? true
      : infoAccount.isAgreePolicy;

  return (
    <>
      <BreadcrumbList listBreadcrumb={breadcrumbList} />
      <div className="admin-container ">
        <div style={{ display: 'flex', padding: '24px' }}>
          <strong>
            가입일 &nbsp;
            {moment(infoAccount.created_at)
              .utc()
              .format('YYYY.MM.DD hh:mm:ss ')}
          </strong>
        </div>
        <Card
          bordered={false}
          className="admin-card"
          style={{
            minHeight: '80vh',
            background: 'none'
          }}
        >
          <div className="wrapMyPageWarehouse custom">
            <div className="wrapTabWare">
              <Tabs
                activeKey={tabActive}
                onChange={(key: any) => {
                  setTabActive(key);
                }}
              >
                <Tabs.TabPane tab="계정 설정" key="1">
                  <SettingAccount
                    id={infoAccount.id}
                    lastName={infoAccount.lastName}
                    firstName={infoAccount.firstName}
                    companyName={infoAccount.companyName}
                    email={infoAccount.email}
                    userPhone={infoAccount.phoneNumber}
                    sellingCountry={infoAccount.saleArea}
                    companyPhone={infoAccount.companyPhoneNumber}
                    companyAddress={infoAccount.companyAddress}
                    detailAddress={infoAccount.detailAddress}
                    detailAddress2={infoAccount.detailAddress2}
                    detailAddress3={infoAccount.detailAddress3}
                    city={infoAccount.city}
                    state={infoAccount.state}
                    exportQuantity={infoAccount.shipmentPerMonth}
                    numberSelling={infoAccount.numberOfProduct}
                    postalCode={infoAccount.postalCode}
                    country={infoAccount.country}
                    saleCategories={sellingCategory}
                    saleChannels={saleChannels}
                    businessLicense={infoAccount?.certificate?.fileName}
                    idImg={infoAccount?.certificate?.id}
                    countryCodeUser={infoAccount?.countryCode}
                    countryCodeCompany={infoAccount?.companyCountryCode}
                  />
                </Tabs.TabPane>

                <Tabs.TabPane tab="연동 설정" key="2">
                  {/* <InfoAmazon sellerId={infoAccount.id} search={search} tab={tabActive} setTabActive={setTabActive} /> */}

                  <LinkSettings
                    isAccepted={isNotShowAgreement}
                    onCancelAgree={() => {
                      setTabActive('1');
                    }}
                    onAgree={updateAgreement}
                  />
                </Tabs.TabPane>
              </Tabs>
            </div>
          </div>
        </Card>
      </div>
    </>
  );
};

export default Mypage;
